import { AppAdmin } from '@f_admin/index';
import { GeneralDrawer } from '@f_components/drawer';
import { Header } from '@f_components/header';
import { AlLicenses } from '@f_components/licenses';
import { MyCompany } from '@f_components/my-company';
import { SettingsPage } from '@f_components/settings';
import { SupportPage } from '@f_components/support';
import { ChatPopper } from '@f_components/support/chat/ChatPopper';
import { GeneralContext } from '@f_context/General_context';
import { AppCrossdata } from '@f_crossdata/index';
import { ErrorBoundaryComponent } from '@f_general/pageError/PageError';
import { useMigratedUserLock } from '@f_hooks/useMigratedUserLock';
import stls from '@f_styles/components/main/Main.module.sass';
import { Apps } from '@f_types/index';
import { AppUCS } from '@f_ucs/index';
import { useContext, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AppQwep } from '../../applications/qwep/index';
import { MigratedUserGuard } from './MigratedUserGuard';

const MIGRATED_ROUTE = '/app-qwep/migrated';

export function Main() {
    const { drawerPanels } = useContext(GeneralContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { isMigratedLocked } = useMigratedUserLock(drawerPanels);

    useEffect(() => {
        if (!drawerPanels.length) {
            return;
        }

        if (isMigratedLocked) {
            if (location.pathname !== MIGRATED_ROUTE) {
                navigate(MIGRATED_ROUTE, { replace: true });
            }
            return;
        }

        if (location.pathname === '/') {
            if (drawerPanels.find((item: any) => item.applicationSysName === Apps.Data)) {
                navigate('/app-crossdata');
            } else if (drawerPanels.find((item: any) => item.applicationSysName === Apps.Qwep)) {
                navigate('/app-qwep');
            } else {
                navigate(`/app-${drawerPanels[0].applicationSysName}`);
            }
        }
    }, [drawerPanels.length, isMigratedLocked, location.pathname]);

    const showMigratedLayout = isMigratedLocked;

    return (
        <MigratedUserGuard>
            <Header showLogout={showMigratedLayout} />
            <ErrorBoundary fallbackRender={() => <ErrorBoundaryComponent />}>
                <main className={stls.main}>
                    {!showMigratedLayout && <GeneralDrawer />}
                    <Routes>
                        <Route path={'settings'} element={<SettingsPage />} />
                        <Route path={'company'} element={<MyCompany />} />
                        <Route path={'support'} element={<SupportPage />} />
                        <Route path={'licenses'} element={<AlLicenses />} />
                        <Route path={'app-qwep/*'} element={<AppQwep />} />
                        <Route path={'app-admin/*'} element={<AppAdmin />} />
                        <Route path={'app-crossdata/*'} element={<AppCrossdata />} />
                        <Route path={'app-ucs/*'} element={<AppUCS />} />
                    </Routes>
                    {!showMigratedLayout && location.pathname !== '/support' && <ChatPopper />}
                </main>
            </ErrorBoundary>
        </MigratedUserGuard>
    );
}
